/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} FormatInputs */

const th_format = /** @type {(inputs: FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`รูปแบบ`)
};

const en_format = /** @type {(inputs: FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Format`)
};

const ja_format = /** @type {(inputs: FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`形式`)
};

const zh_format = /** @type {(inputs: FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`赛制`)
};

const es_format = /** @type {(inputs: FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formato`)
};

const pt_format = /** @type {(inputs: FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formato`)
};

const id_format = /** @type {(inputs: FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Format`)
};

const fr_format = /** @type {(inputs: FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Format`)
};

const tl_format = /** @type {(inputs: FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pormat`)
};

const vi_format = /** @type {(inputs: FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thể thức`)
};

const ko_format = /** @type {(inputs: FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`방식`)
};

const de_format = /** @type {(inputs: FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Format`)
};

const ru_format = /** @type {(inputs: FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Формат`)
};

const tr_format = /** @type {(inputs: FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Format`)
};

const it_format = /** @type {(inputs: FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formato`)
};

const pl_format = /** @type {(inputs: FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Format`)
};

const uk_format = /** @type {(inputs: FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Формат`)
};

const hi_format = /** @type {(inputs: FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रारूप`)
};

const ar_format = /** @type {(inputs: FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`النظام`)
};

const ms_format = /** @type {(inputs: FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Format`)
};

const bn_format = /** @type {(inputs: FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ধরন`)
};

const zh_tw2_format = /** @type {(inputs: FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`賽制`)
};

const zh_hk2_format = /** @type {(inputs: FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`賽制`)
};

const ur_format = /** @type {(inputs: FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`طریقہ`)
};

const fa_format = /** @type {(inputs: FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`قالب`)
};

const sw_format = /** @type {(inputs: FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muundo`)
};

const nl_format = /** @type {(inputs: FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opzet`)
};

/**
* | output |
* | --- |
* | "Format" |
*
* @param {FormatInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const format = /** @type {((inputs?: FormatInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<FormatInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_format(inputs)
	if (locale === "ja") return ja_format(inputs)
	if (locale === "zh") return zh_format(inputs)
	if (locale === "es") return es_format(inputs)
	if (locale === "pt") return pt_format(inputs)
	if (locale === "id") return id_format(inputs)
	if (locale === "fr") return fr_format(inputs)
	if (locale === "tl") return tl_format(inputs)
	if (locale === "vi") return vi_format(inputs)
	if (locale === "ko") return ko_format(inputs)
	if (locale === "de") return de_format(inputs)
	if (locale === "ru") return ru_format(inputs)
	if (locale === "tr") return tr_format(inputs)
	if (locale === "it") return it_format(inputs)
	if (locale === "pl") return pl_format(inputs)
	if (locale === "uk") return uk_format(inputs)
	if (locale === "hi") return hi_format(inputs)
	if (locale === "ar") return ar_format(inputs)
	if (locale === "ms") return ms_format(inputs)
	if (locale === "bn") return bn_format(inputs)
	if (locale === "zh-TW") return zh_tw2_format(inputs)
	if (locale === "zh-HK") return zh_hk2_format(inputs)
	if (locale === "ur") return ur_format(inputs)
	if (locale === "fa") return fa_format(inputs)
	if (locale === "sw") return sw_format(inputs)
	if (locale === "nl") return nl_format(inputs)
	return en_format(inputs)
});